import { Currency } from '@configs/language';
import { Currencies } from '@constants/enums';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useSelector } from 'react-redux';
import { selectRealtimeExchange } from '@/modules/rate/realtime/selectors';

const useWalletCard = () => {
  const realtimeExchange = useSelector(selectRealtimeExchange);
  const userProfile = useSelector(selectProfileData);
  const { isAwActive } = userProfile || {};

  const getExchangeV2 = (
    currency: Currency,
    originCurrency = Currencies.USD
  ) => {
    if (!realtimeExchange) {
      return null;
    }
    const realtimeRate = (realtimeExchange as any).find(
      (rate: any) =>
        rate.currency === originCurrency && rate.des_currency === currency
    );
    return realtimeRate || null;
  };

  return {
    getExchangeV2,
    isAwActive,
  };
};

export default useWalletCard;
